import NewsletterForm from "../modules/Forms/NewsletterForm";

NewsletterForm();


const progressLine = document.querySelector('.inside-bar1');
var swiper = new Swiper(".mySwiper", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          progressLine.style.setProperty("--progress", progress);
        }
      }

});
const progressLine2 = document.querySelector('.inside-bar2');
var swiper2 = new Swiper(".mySwiper2", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          progressLine2.style.setProperty("--progress", progress);
        }
      }
});

const sliderVinhos = document.querySelector('.slider-vinhos');

if (sliderVinhos) {
    const bottlesContainer = sliderVinhos.querySelector('.bottles-controll');
    const bulletsContainer = sliderVinhos.querySelector('.nav-controlls-bullet');
    const swiperWrapper = sliderVinhos.querySelector('.mySwiper3 .swiper-wrapper');
    const ball = bulletsContainer.querySelector('.ball-vinhos');

    const allBottles = Array.from(bottlesContainer.querySelectorAll('.bottle-box'));
    const allBullets = Array.from(bulletsContainer.querySelectorAll('.nav-bullet'));
    const allSlides = Array.from(swiperWrapper.querySelectorAll('.swiper-slide'));

    let swiper3 = null;

    function changeBackground(color, image) {
        gsap.to(sliderVinhos, {
            duration: 0.2,
            backgroundColor: color,
        })
        gsap.set(sliderVinhos, { 'css': { 'backgroundImage': 'url(' + image + ')' } })
    };

    function moveBall(activeIndex, totalSlides) {
        if (totalSlides > 1) {
            const percent = (activeIndex / (totalSlides - 1)) * 97;
            gsap.to(ball, {
                left: percent + '%',
            })
        } else {
            gsap.to(ball, {
                left: 0,
            })
        }
    }

    function buildSwiper3() {
        swiper3 = new Swiper(".mySwiper3", {
            effect: "fade",
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                slideChange: function () {
                    const activeSlide = this.slides[this.activeIndex];
                    if (!activeSlide) return;
                    const bgColor = activeSlide.getAttribute("data-bg-color");
                    const bgImage = activeSlide.getAttribute("data-bg-image");
                    changeBackground(bgColor, bgImage);

                    const bullets = bulletsContainer.querySelectorAll('.nav-bullet');
                    bullets.forEach(item => item.classList.remove('active'));
                    const activeBullet = bullets[this.activeIndex];
                    if (activeBullet) activeBullet.classList.add('active');

                    moveBall(this.activeIndex, this.slides.length);
                },
            },
        });
    }

    // delegado uma única vez: como as trocas de categoria reaproveitam os
    // elementos originais (não clones), o índice do clique é sempre calculado
    // na hora, contra a posição atual entre os itens visíveis.
    bottlesContainer.addEventListener('click', (e) => {
        const bottle = e.target.closest('.bottle-box');
        if (!bottle || !swiper3) return;
        const index = Array.from(bottlesContainer.querySelectorAll('.bottle-box')).indexOf(bottle);
        if (index > -1) swiper3.slideTo(index);
    });

    function renderCategory(categoryId) {
        const matches = (el) => el.getAttribute('data-category') === categoryId;

        // reaproveita os nós originais (não clona): eles já foram registrados pelo
        // IntersectionObserver de reveal-on-scroll do site na carga da página, e um
        // clone nunca seria observado, ficando preso em opacity:0 pra sempre.
        bottlesContainer.querySelectorAll('.bottle-box').forEach(el => el.remove());
        allBottles.filter(matches).forEach(el => bottlesContainer.insertBefore(el, bulletsContainer));

        bulletsContainer.querySelectorAll('.nav-bullet').forEach(el => el.remove());
        allBullets.filter(matches).forEach(el => bulletsContainer.insertBefore(el, ball));

        swiperWrapper.innerHTML = '';
        allSlides.filter(matches).forEach(el => swiperWrapper.appendChild(el));

        const bullets = bulletsContainer.querySelectorAll('.nav-bullet');
        bullets.forEach(b => b.classList.remove('active'));
        if (bullets[0]) bullets[0].classList.add('active');

        bottlesContainer.classList.toggle('single-item', bullets.length <= 1);

        // o reveal-on-scroll do site (enterElements.js) só observa os elementos
        // que já estavam no DOM na carga da página; um item de outra categoria,
        // que a gente acabou de reconectar aqui, nunca teria essa chance (a seção
        // pode nem ter entrado na viewport ainda). Como o clique na aba já é uma
        // ação explícita do usuário, revela na hora em vez de depender disso.
        sliderVinhos.querySelectorAll('[data-animation]').forEach(el => el.classList.add('animated-element'));

        if (swiper3) swiper3.destroy(true, true);
        buildSwiper3();

        const firstSlide = swiperWrapper.querySelector('.swiper-slide');
        if (firstSlide) {
            changeBackground(firstSlide.getAttribute('data-bg-color'), firstSlide.getAttribute('data-bg-image'));
        }
        moveBall(0, bullets.length);
    }

    document.querySelectorAll('.category-filter-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            document.querySelectorAll('.category-filter-btn').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            renderCategory(btn.getAttribute('data-category'));
        });
    });

    // sem aba "Todos": some estado inicial já entra filtrado na primeira categoria
    // (marcada como active no blade) pra nunca mostrar a lista inteira misturada.
    const defaultCategoryBtn = document.querySelector('.category-filter-btn.active') || document.querySelector('.category-filter-btn');
    if (defaultCategoryBtn) {
        renderCategory(defaultCategoryBtn.getAttribute('data-category'));
    } else {
        // sem categorias cadastradas ainda: usa o markup renderizado pelo servidor sem
        // tocar no DOM, pra não atropelar as animações de entrada que outros scripts
        // já ligaram nesses elementos originais.
        bottlesContainer.classList.toggle('single-item', allBottles.length <= 1);
        buildSwiper3();
    }
}


//cursor
gsap.set(".ball", { xPercent: -50, yPercent: -50, display: "flex" });

var ball = document.querySelector(".ball");
var pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
var mouse = { x: pos.x, y: pos.y };
var speed = 0.6;

var xSet = gsap.quickSetter(ball, "x", "px");
var ySet = gsap.quickSetter(ball, "y", "px");

window.addEventListener("mousemove", e => {
    mouse.x = e.x;
    mouse.y = e.y;
});
gsap.ticker.add(() => {
    var dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

    pos.x += (mouse.x - pos.x) * dt;
    pos.y += (mouse.y - pos.y) * dt;
    xSet(pos.x);
    ySet(pos.y);
});

gsap.set(ball, { scale: 0 })
//function mousemoveFunction(e) {
//    mouse.x = e.x;
//    mouse.y = e.y;
//}
//
//function tickerUpdate() {
//  var dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
//
//  pos.x += (mouse.x - pos.x) * dt;
//  pos.y += (mouse.y - pos.y) * dt;
//  xSet(pos.x);
//  ySet(pos.y);
//}
let cursorOff = document.querySelectorAll("[data-id='cursor']")

let section = document.querySelector(".banner-gif");
section.onmouseenter = function () {
    //section.addEventListener("mousemove", mousemoveFunction);
    //gsap.ticker.add(tickerUpdate)
    gsap.to(ball, { scale: 1 })
}

section.onmouseleave = function () {
    //section.removeEventListener("mousemove", mousemoveFunction);
    //gsap.ticker.remove(tickerUpdate)
    gsap.to(ball, { scale: 0 })
}

cursorOff.forEach((e) => {
    e.onmouseenter = function () {
        gsap.to(ball, { scale: 0 })
    }
    e.onmouseleave = function () {
        gsap.to(ball, { scale: 1 })
    }
})

$('.wrapper-text').on('mouseenter', function(){
    gsap.to('.wrapper-text h3', {
        duration: .1,
        zIndex: 99,
        scale: 1.1,
        ease: "power2.out",
    })

})
$('.wrapper-text').on('mouseleave', function(){
    gsap.to('.wrapper-text h3', {
        duration: .1,
        ease: "power2.out",
        zIndex: -1,
        scale: 1,
        position : 'relative',
    })

})
